import { AfterViewInit, Component, inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { FormulaireMouvementService } from '@services/formulaire-mouvement/formulaire-mouvement.service';
import { FormulaireCoordonneesMouvementCourrielModel } from '../../models/formulaire/formulaire-coordonnees-mouvement-courriel.model';
import { RequeteCoordonneesMouvementService } from '@services/requete-coordonnees-mouvement/requete-coordonnees-mouvement.service';
import { NavigationService } from '@services/navigation/navigation.service';
import { GabaritService } from '@services/gabarit/gabarit.service';
import { GestionTitreService } from '@services/navigation/gestion-titre.service';
import { GlobalStoreService } from '@services/global-store/global-store.service';
import { TypeModificationEnum } from 'src/app/constantes/type-modification.enum';
import { CybermetrieCoordonneesService } from '@services/cybermetrie/cybermetrie.service';
import { CybermetrieEnum } from '../../constantes/cybermetrie.enum';
import { AccessibiliteService } from '@services/accessibilite.service';

@Component({
  selector: 'app-page-validation',
  templateUrl: './page-validation-courriel.component.html',
  standalone: false,
})
export class PageValidationCourrielComponent implements OnInit, AfterViewInit {
  isAppMobile?: boolean;
  form?: FormGroup<FormulaireCoordonneesMouvementCourrielModel> | null;

  private readonly formulaireMouvementService = inject(FormulaireMouvementService);
  private readonly requeteCoordonneesMouvementService = inject(RequeteCoordonneesMouvementService);
  private readonly navigationService = inject(NavigationService);
  private readonly gabaritService = inject(GabaritService);
  private readonly globalStoreService = inject(GlobalStoreService);
  private readonly gestionTitreService = inject(GestionTitreService);
  private readonly cybermetrieCoordonneesService = inject(CybermetrieCoordonneesService);
  private readonly accessibiliteService = inject(AccessibiliteService);

  ngOnInit(): void {
    this.gestionTitreService.addTitreOnglet('titreOnglet.pageValidation');
    this.isAppMobile = this.gabaritService.isAppMobile();
    this.form = this.formulaireMouvementService.getFormCourriel();
    this.cybermetrieCoordonneesService.transactionEtape(
      this.form?.value.courrielExistant
        ? CybermetrieEnum.LABEL_MODIFIER_COURRIEL
        : CybermetrieEnum.LABEL_MODIFIER_COURRIEL_AJOUT,
    );
  }

  ngAfterViewInit(): void {
    this.accessibiliteService.setFocus('#titreValidationCourriel');
  }

  get courriel(): string {
    return this.form?.value.courriel ?? '';
  }

  naviguerVersModifier(): void {
    this.navigationService.naviguerVersModifierCourriel();
    this.cybermetrieCoordonneesService.actionClick(
      CybermetrieEnum.LABEL_MODIFIER_COURRIEL_VALIDATION,
    );
  }

  naviguerVersConfirmation(): void {
    const requete = this.requeteCoordonneesMouvementService.construireRequeteModifierCourriel();
    this.globalStoreService.modifierCoordonneMouvement$(requete).subscribe({
      next: () => {
        this.navigationService.naviguerVersConfirmationCourriel(this.typeModification());
      },
    });
  }

  annuler(): void {
    this.globalStoreService.saveEtatAfficherModaleAnnuler(true);
  }

  typeModification(): TypeModificationEnum {
    return this.form?.getRawValue().courrielExistant
      ? TypeModificationEnum.MODIFICATION
      : TypeModificationEnum.AJOUT;
  }
}
